import { render, staticRenderFns } from "./ReContactHao.vue?vue&type=template&id=05d637fa&lang=pug&"
import script from "./ReContactHao.vue?vue&type=script&lang=js&"
export * from "./ReContactHao.vue?vue&type=script&lang=js&"
import style0 from "./ReContactHao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports